import {takeUntil} from 'rxjs/operators';
import {Component, OnDestroy, OnInit} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {AuthenticationService} from '@modules/authentication/core/authentication.service';
import {Router} from '@angular/router';
import {Subject} from 'rxjs';
import {brand, brandLogoSvg, modulesSettings} from 'app/settings';
import {ModelSchema, Structures} from 'octopus-model';

const settingsAuthStructure: ModelSchema = new ModelSchema({
    displayLoginLogo: Structures.boolean(false),
});

@Component({
    selector: 'fuse-forgot-password',
    templateUrl: './forgot-password.component.html',
})
export class FuseForgotPasswordComponent implements OnInit, OnDestroy {
    forgotPasswordForm: UntypedFormGroup;
    forgotPasswordFormErrors: any;
    public emailNotValidated: boolean = false;
    public brand = brand;
    public brandLogoSvg = brandLogoSvg;
    settingsAuth: { [key: string]: boolean };
    private unsubscribeInTakeUntil = new Subject<void>();

    constructor(
        private formBuilder: UntypedFormBuilder,
        private authenticationService: AuthenticationService,
        private router: Router,
    ) {
        this.forgotPasswordFormErrors = {
            email: {}
        };

        this.settingsAuth = settingsAuthStructure.filterModel(modulesSettings.authentication);
    }

    ngOnInit(): void {
        this.forgotPasswordForm = this.formBuilder.group({
            email: ['', [Validators.required, Validators.email]]
        });

        this.forgotPasswordForm.valueChanges.subscribe(() => {
            this.onForgotPasswordFormValuesChanged();
        });
    }

    ngOnDestroy(): void {
        this.unsubscribeInTakeUntil.next();
        this.unsubscribeInTakeUntil.complete();
    }

    onForgotPasswordFormValuesChanged(): void {
        this.emailNotValidated = false;
        for (const field in this.forgotPasswordFormErrors) {
            if (!this.forgotPasswordFormErrors.hasOwnProperty(field)) {
                continue;
            }

            // Clear previous errors
            this.forgotPasswordFormErrors[field] = {};

            // Get the control
            const control = this.forgotPasswordForm.get(field);

            if (control && control.dirty && !control.valid) {
                this.forgotPasswordFormErrors[field] = control.errors;
            }
        }
    }

    sendResetLink(): void {
        if (!this.forgotPasswordForm.invalid) {
            this.authenticationService.forgotPassword(this.forgotPasswordForm.value['email']).pipe(
                takeUntil(this.unsubscribeInTakeUntil))
                .subscribe(res => {
                    this.router.navigate(['password-reset-email']);
                }, error => {
                    if (error.code === 403) {
                        this.emailNotValidated = true;
                    }
                });
        }
    }
}
